'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.stickyNav = twentyninetimes.stickyNav || function () {

	function init() {
		var sticky_nav = document.querySelector('.sticky-nav');
		if ( sticky_nav ) {
      if ( window.innerWidth >= 768 ) {
			  flexibleNav(sticky_nav);
      }
			//stickyNavFunction(sticky_nav);
		}
	}

	function flexibleNav(sticky_nav) {
		var nav 			= sticky_nav,
			btn 			= sticky_nav.querySelector('.sticky-nav__btn'),
			visible_links 	= sticky_nav.querySelector('.sticky-nav__links'),
			visible_items 	= visible_links.querySelectorAll('li'),
			hidden_links	= sticky_nav.querySelector('.sticky-nav__hidden-links');

		var numOfItems 		= 0,
			totalSpace 		= 0,
			breakWidths 	= [];

		visible_items.forEach( (item) => {
			var w = item.getBoundingClientRect().width;

			totalSpace += w;
			numOfItems += 1;
			breakWidths.push(totalSpace);
		});

		var availableSpace, 
			numOfVisibleItems, 
			requiredSpace;

		function check() {
			var visible_items 	= visible_links.querySelectorAll('li'),
				hidden_items 	= hidden_links.querySelectorAll('li');

			// Get instant state
			availableSpace = visible_links.getBoundingClientRect().width - 10;
			numOfVisibleItems = visible_items.length;
			requiredSpace = breakWidths[numOfVisibleItems - 1];

			// There is not enought space
			if (requiredSpace > availableSpace) {
				hidden_links.prepend(visible_items[visible_items.length - 1]);
				numOfVisibleItems -= 1;
				check();
			// There is more than enough space
			} else if (availableSpace > breakWidths[numOfVisibleItems]) {
				visible_links.append(hidden_items[0]);
				numOfVisibleItems += 1;
			}
			// Update the button accordingly
			btn.setAttribute('count', numOfItems - numOfVisibleItems);
			(numOfVisibleItems === numOfItems)
				? btn.classList.add('hidden')
				: btn.classList.remove('hidden');
		}
		
		window.addEventListener('resize', check);

		btn.addEventListener('click', (e) => {
			e.stopPropagation();

      hidden_links.classList.toggle('active');
		});

    document.addEventListener('click', (e) => {
      if ( !hidden_links.contains(e.target) && !btn.contains(e.target) ) {
        hidden_links.classList.remove('active');
      }
    });

    check();

    setTimeout( () => {
      check();
    }, 150);
	}

	function stickyNavFunction(sticky_nav) {
    var offset = window.innerWidth >= 768 ? 0 : 20;
		var sticky_nav_top = sticky_nav.offsetTop - offset;

		window.addEventListener('scroll', (e) => {
			var curScroll = window.scrollY || document.scrollTop;

			( curScroll > sticky_nav_top ) 
			  ? sticky_nav.classList.add('scrolled')
			  : sticky_nav.classList.remove('scrolled');
		});
	}

	return {
		init : init
	};

}();